import LessIcon from './LessIcon';
export default LessIcon;
